export const CHANGE_FILTER = "CHANGE_FILTER";
export const SET_PAGE = "SET_PAGE";
